import { AcademictimetableActions } from "./action";
import { takeEvery, call, all, put } from "redux-saga/effects";
import { API_URL } from "../../utils/Constant";
import axios from "axios";

export const AcademictimetableSagas = function* () {
  yield all([
    takeEvery(
      AcademictimetableActions.GET_ACADEMIC_TIMETABLE,
      getAcademictimetableInfo
    ),
  ]);
};

const getAcademictimetableInfo = function* (action) {
  try {
    const year = action.payload?.year;
    

    if (!year) {
    
      return;
    }

    const result = yield call(() =>
      axios.get(`${API_URL}/academic_timetable/${year}`)
    );

    // Add detailed logging
  
    // console.log("Response structure:", {
    //   isArray: Array.isArray(result.data),
    //   hasAcademicTimetable: !!result.data?.academic_timetable,
    //   academicTimetableIsArray: Array.isArray(result.data?.academic_timetable),
    //   academicTimetableLength: result.data?.academic_timetable?.length
    // });

    yield put({
      type: AcademictimetableActions.SET_ACADEMIC_TIMETABLE,
      payload: result.data,
    });
  } catch (error) {
    console.error("Error fetching academic timetable:", error.response || error);
  }
};